import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';

const routes = {
  getInfoSubCA: '/service-types/get-info-subca',
  filter: '/service-types/get-all',
  create: `/service-types/create`,
  update: `/service-types/update`,
  delete: (id) => `/service-types/delete/${id}`,
  deleteAll: () => '/service-types/delete-all',
  getServiceTypeById: (id: any) => `/service-types/get-service-types/${id}`,
  getAllEnterpriseAssigned: '/service-types/get-all-service-type-admin',
  searchEnterprise: '/enterprises/filter-enterprise-service-type',
  assignEnterprise: '/service-types/assign-enterprise',
  //Đồng bộ
  filterSync: '/service-types/get-all-sync',
  syncServiceType: '/service-types/sync'
};
@Injectable({
  providedIn: 'root'
})
export class ServiceTypeService {

  constructor(
    private apiService: ApiService
  ) { }

  getInfoSubCA(){
    return this.apiService.post(routes.getInfoSubCA, {})
    .pipe(map(res=>{
      return res;
    }));
  }

  filterServiceTypes(filter: any) {
    return this.apiService.postSilently(routes.filter, filter)
      .pipe(map(res => {
        return res;
      }));
  }

  getAllEnterpriseAssigned(body: any) {
    return this.apiService.post(routes.getAllEnterpriseAssigned, body)
      .pipe(map(res => {
        return res;
      }));
  }

  assignEnterprise(body: any) {
    return this.apiService.post(routes.assignEnterprise, body)
      .pipe(map(res => {
        return res;
      }));
  }

  searchEnterprise(body: any) {
    return this.apiService.post(routes.searchEnterprise, body)
      .pipe(map(res => {
        return res;
      }));
  }

  createServiceTypes(serviceType: any, errCallback?: any) {
    return this.apiService.post(routes.create, serviceType)
      .pipe(map(res => {
        if (errCallback && !res.success) { errCallback(res); }
        return res;
      }));
  }

    updateServiceTypes(serviceType: any, errCallback?: any) {
    return this.apiService.post(routes.update, serviceType)
      .pipe(map(res => {
        if (errCallback && !res.success) { errCallback(res); }
        return res;
      }));
  }

  // updateServiceTypes(serviceType: any, callBack: any, noCallBack: any, errCallback: any) {
  //   return this.apiService.putAndCheckVersion(
  //     routes.update,
  //     serviceType,
  //     callBack,
  //     noCallBack,
  //     errCallback
  //   );
  // }

  deleteCustomer(serviceTypeId: number) {
    return this.apiService.get(routes.delete(serviceTypeId)).pipe(map(res => {
      return res;
    }));
  }

  deleteAll(ids: any) {
    return this.apiService.post(routes.deleteAll(), ids)
  }

  getServiceTypeById(serviceTypeId: any) {
    return this.apiService.get(routes.getServiceTypeById(serviceTypeId)).pipe(
        map(rs => {
          return rs;
        })
    );
  }

  getAllServiceTypeAdmin(params: any) {
    return this.apiService.post(`/service-types/get-all-admin`, params)
      .pipe(map(res => {
        return res;
      }));
  }

  createServiceTypesAdmin(serviceType: any, errCallback?: any) {
    return this.apiService.post(`/service-types/create-admin`, serviceType)
      .pipe(map(res => {
        if (errCallback && !res.success) { errCallback(res); }
        return res;
      }));
  }

  updateServiceTypesAdmin(serviceType: any, errCallback?: any) {
    return this.apiService.post(`/service-types/update-admin`, serviceType)
      .pipe(map(res => {
        if (errCallback && !res.success) { errCallback(res); }
        return res;
      }));
  }

  deleteServiceType(serviceTypeId: number) {
    return this.apiService.get(`/service-types/delete-admin/${serviceTypeId}`).pipe(map(res => {
      return res;
    }));
  }

  getServiceTypeByIdAdmin(serviceTypeId: any) {
    return this.apiService.get(`/service-types/get-service-types-admin/${serviceTypeId}`).pipe(
      map(rs => {
        return rs;
      })
    );
  }
  /**
   * Get list service type sync
   * @param filter
   * @returns
   */
  filterSyncServiceTypes(filter: any) {
    return this.apiService.post(routes.filterSync, filter)
      .pipe(map(res => {
        return res;
      }));
  }

  /**
   * Sync service type
   */
   syncServiceTypes(data: any) {
    return this.apiService.post(routes.syncServiceType, data)
      .pipe(map(res => {
        return res;
      }));
  }
}
